module.exports = __webpack_public_path__ + "img/banking.8f5a8f5a.svg";